<template>
  <div class="order-list-item">
    <v-card
      class="pa-2 mb-3 rounded-card"
      hover
    >
      <v-row
        align="center"
        no-gutters
      >
        <v-col sm="1">
          <div style="display: inline-flex;">
            <div class="arrow">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </v-col>
        <v-col sm="7">
          <v-row no-gutters class="pb-1">
            <v-col>
              <div class="order-ref">
                {{ transporRequest.originAddress.reference_number }}
              </div>
            </v-col>
            <v-col>
              {{ transporRequest.originAddress.dates_from | dateToReadable($i18n.locale) }}
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-2">
            <v-col>
              <div class="company-name">
                {{ transporRequest.originAddress.company }}
              </div>
            </v-col>
            <v-col>
              {{ transporRequest.originAddress.locShort }}
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters class="pt-2">
            <v-col>
              <div class="order-ref">
                {{ transporRequest.destinationAddress.reference_number }}
              </div>
            </v-col>
            <v-col>
              {{ transporRequest.destinationAddress.dates_from | dateToReadable($i18n.locale) }}
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              {{ transporRequest.destinationAddress.company }}
            </v-col>
            <v-col>
              {{ transporRequest.destinationAddress.locShort }}
            </v-col>
          </v-row>
        </v-col>

        <v-col
          sm="1"
          style="border-left: 1px solid lightgray; padding-left:5px;"
        >
          <v-row no-gutters class="pb-1">
            <v-col>
              {{ totalWeight | roundValue(1) }} kg
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              {{ totalVolume | roundValue(1) }} m&sup3;
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              {{ transporRequest.cargos.length }} pkgs
            </v-col>
          </v-row>
        </v-col>
        <v-col class="text-center" sm="2">
          <b>{{transporRequest.objectID}}</b>
          <div class="pt-1">
            <v-chip
              v-if="transporRequest.transportRequestStatus"
              outlined
              label
              small
            >
              <span class="chip">
                {{ $t('transport_request.'+transporRequest.transportRequestStatus) }}
              </span>
            </v-chip>
          </div>
        </v-col>
        <v-col sm="1">
          <v-btn
            text
            icon
            color="kazan"
            @click="gotoDetail(transporRequest.objectID) "
          >
            <v-icon>launch</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'TransportRequestListItem',
  components: {},
  props: {
    transporRequest: Object
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    totalWeight () {
      let total = 0
      this.transporRequest.cargos.forEach(cargo => {
        total += Number(cargo.weight)
      })
      return total
    },
    totalVolume () {
      let total = 0
      this.transporRequest.cargos.forEach(cargo => {
        total += (cargo.length * cargo.width * cargo.height) * 0.000001
      })
      return total
    }
  },
  methods: {
    gotoDetail (objectID) {
      router.push({ name: 'TransportRequestEdit', params: { transportRequestID: objectID } })
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
.v-card {
  cursor: auto;
}
.company-name, .order-ref {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 16px;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.company-name:hover, .order-ref:hover {
  max-height: 100px;
  -webkit-line-clamp: 5; /* number of lines to show */
  -webkit-box-orient: vertical;
}
::v-deep.v-chip .v-chip__content {
  padding: 0 5px;
}
.chip {
  font-size: 10px;
}
.order-list-item {
  font-size: 12px;
}

.seller-info:after {
  content: "";
  display: block;
  width: 90%;
  border-bottom: 1px solid lightgray;
  padding: 3px 0 6px 0;
}

// Arrows
.arrow {
  position: absolute;
  top: 50px;
  left: 8.5%;
  transform: translate(-50%, -50%);
}
.arrow span {
  display: block;
  width: 4px;
  height: 4px;
  border-bottom: 1px solid lightgray;
  border-right: 1px solid lightgray;
  transform: rotate(45deg);
  margin: -10px;
  animation: animate 3s infinite;
}
@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-10px, -10px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(30px, 30px);
  }
}

@media screen and (max-width: 830px) {
  .arrow {
    display: none;
  }
}
.expansion-btn {
  margin: 0;
  width: 22px;
  height: 22px;
}
.order-packages {
  border-top: 1px lightgray solid;
  max-height: 180px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
